import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { URL_KKN_JOENSUU } from "../url/index";

class Appointment extends Component {
  render() {
    const { t } = this.props;
    return (
      <div>
        <section class="gallery py-5" id="gallery">
          <div class="container py-md-5">
            <h3 class="heading text-center mb-3 mb-sm-5">
              {t("nav.appointment")}
            </h3>
            <div class="gallery-content">
              <iframe
                title="appoointment"
                src={URL_KKN_JOENSUU}
                width="100%"
                height="900px"
                frameborder="0"
              />
            </div>
          </div>
        </section>
      </div>
    );
  }
}

export default withTranslation("global")(Appointment);
